module.exports = __webpack_public_path__ + "static/img/al7.5ca0d3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/al7.jpg
// module id = dtQg
// module chunks = 1